import React, {useState} from 'react';
import img1 from "../../Images/CourseGenereric.jpg"
//import img1 from "../../Images/Landing.jpg"
import "./CMSNews.css"
import { Link } from 'react-router-dom';


function CMSNews() { 
 

  return <>

      <div className='CMSCover'>  

      <div className='CMSWording'>
            
            <h3 className="solidLine">NEW COMPREHENSIVE PROGRAM </h3>

       </div>

  <div className='courseWholeCoverNew'>

  
      <div className='wholeNewCard'>
            {/* <Link className='LinkItems' to={"/Courses"}> */}

            <div className='NewcourseImg'>

              <img alt='University of lusaka UNILUS shortcourses' src={img1} />
              
            </div>  
            <div className='workingWholeCover'> 

                  <div className='courseWording'> 

                        <div className='Heading'><h2>Digital Marketing</h2></div>
                        {/* <div className='Lecturer'><p>Proffessor Jere Mulenga</p></div> */}
                        <div className='Pretext'> <p>Develop digital marketing strategies that reach and retain customers.</p></div>

                  </div>
                  <div className='courseMetrics'>

                          <div className='enrollDuration'>
                                  <p>4 weeks, 2 - 3 hrs/week</p>
                          </div>
                          <div className='enrollhrs'>
                                   
                          </div>
                          <div className='enrollDeadline'> 

                                <p>Apply for the next cohort</p>
                          </div>
                          <div className='enrollPrice'>

                                  <p><b>ZMK 3,500</b></p>
                                  <p><button className='viewCourse'><Link className='LinkItems' to={"/Courses/MKT100"}>View Course</Link></button></p>

                          </div>
              
                 </div>

            </div>
       
             {/* </Link> */}

      </div>

     

  </div>
  {/* Close single card Components */}

      </div>
      
       
    
  </>
  
  ;
}

export default CMSNews;